/** Empty-state copy shared across screens. */
const dictionary = {
  en: {
    noCompetences: "No competences at the moment",
    noMotivationalFactors: "No motivational factors at the moment",
    noData: "no data",
  },
  de: {
    noCompetences: "Derzeit keine Kompetenzen",
    noMotivationalFactors: "Derzeit keine Motivationsfaktoren",
    noData: "keine Daten",
  },
  "fi": {
    "noCompetences": "Ei pätevyyttä tällä hetkellä",
    "noMotivationalFactors": "Ei motivaatiotekijöitä tällä hetkellä",
    "noData": "ei dataa"
  }
};

export default dictionary;
